<ng-container *ngIf="isVisible()">
  <div [id]="navLink.id">
    <div class="ds-grid container-fluid">
      <div class="row justify-content-center">
        <h3 *ngIf="servicePlan?.name"
            [class.d-sm-none]="hasContentForFeatureSection"
            class="col-12 text-center pb-5 ds-heading--l mb-0"
        >
          {{servicePlan.description ? servicePlan.description : servicePlan.name}}
        </h3>
        <div class="col-12 col-sm-5 col-md-4 col-lg-3">
          <dcp-plans-and-pricing-display
            [bundleTemplate]="bundleTemplate"
            [priceDisplay]="priceDisplay"
            [ratePlans]="ratePlans"
            [servicePlan]="servicePlan"
            [showHeadline]="!hasContentForFeatureSection"
          ></dcp-plans-and-pricing-display>
        </div>
        <div class="col-12 col-sm-6">
          <dcp-plans-and-pricing-features
            [commitmentPeriod]="priceDisplayOptions?.hideCommitmentPeriodIdInFeatures ? undefined : commitmentPeriod"
            [includes]="includes"
            [restrictions]="restrictions"
            [servicePlan]="servicePlan"
            [bundleTemplate]="bundleTemplate"
            [hasContentForFeatureSection]="hasContentForFeatureSection"
          ></dcp-plans-and-pricing-features>
        </div>
      </div>
    </div>
  </div>
</ng-container>
